import React from 'react';

function UnitDiscrepancyDetailCell({ row }) {
    const result = row?.expectedResults?.[0];

    return (
        <div key={result?.expectedResultID} style={{ margin: '10px 0px' }}>
            <div>
                <strong>Item: </strong>
                {result?.itemName}
            </div>
            <div>
                <strong>Lot: </strong>
                {result?.expectedLotID}
                <strong> Sku: </strong>
                {row?.externalSku}
            </div>
            {result?.expectedPalletID && (
                <div>
                    <strong>Pallet: </strong>
                    {result?.expectedPalletID}
                </div>
            )}
            <div>
                <strong>Expected: </strong>
                {result?.totalExpectedUnits?.toLocaleString()} units ({result?.expectedCaseCount?.toLocaleString()}{' '}
                cases, {result?.expectedLooseUnitCount?.toLocaleString()} loose units)
            </div>
            <div>
                <strong>Actual: </strong>
                {result?.totalActualUnits?.toLocaleString()} units ({result?.actualCaseCount?.toLocaleString()} cases,{' '}
                {result?.actualLooseUnitCount?.toLocaleString()} loose units)
            </div>

            <div>
                <strong>Proposed Adjustment: </strong>
                {row?.totalUnitDifference > 0 ? '+' : ''}
                {row?.totalUnitDifference?.toLocaleString()} units
            </div>
        </div>
    );
}

export { UnitDiscrepancyDetailCell };
